class EngravingTypesAndPreview extends HTMLElement {
  constructor() {
    super();
    this.engravingData = this.getEngravingData();
    this.currentProductEngravingOptions =
      this.engravingData?.currentProductEngravingOptions;
  }

  connectedCallback() {
    this.initElements();
    this.attachEventListeners();

    this.initializeEngraving();
  }

  disconnectedCallback() {
    this.engravingTypesContainer.removeEventListener("input", (event) =>
      this.engravingTypesEventHandler(event)
    );
  }

  /**
   * Initializes  elements.
   */
  initElements() {
    this.engravingTypesContainer = this.querySelector(
      "#engraving-component--engraving-types"
    );

    this.engravingPreviewContainer = this.querySelector(
      "#engraving-component--engraving-previews"
    );
  }

  /**
   * Attaches event listeners for modal interactions.
   */
  attachEventListeners() {
    this.engravingTypesContainer.addEventListener("input", (event) =>
      this.engravingTypesEventHandler(event)
    );

    document.addEventListener(
      "engravingLineInput",
      this.handleEngravingLineInput.bind(this)
    );

    document.addEventListener("cartItemAddEngraving", (event) => {
      this.currentProductEngravingOptions =
        event.detail.currentProductEngravingOptions;
      this.initializeEngraving();
    });

    document.addEventListener("mainProductOpenModalEvent", () => {
      this.currentProductEngravingOptions =
        this.engravingData?.currentProductEngravingOptions;
      this.initializeEngraving();
    });

    document.addEventListener("cartItemEditEngraving", (event) => {
      this.currentProductEngravingOptions =
        event.detail.currentProductEngravingOptions;
      this.initializeEngraving();
    });
  }

  /**
   * Handles engraving type selection events.
   * @param {Event} event - The input event.
   */
  engravingTypesEventHandler(event) {
    const selectedEngravingType = event.target.value;
    this.hideAllElements(".engraving-preview-element");
    this.showEngravingPreview(selectedEngravingType);

    const engravingTypeEvent = new CustomEvent("engravingTypeSelected", {
      detail: {
        engravingType: selectedEngravingType,
        engravingLines: this.getEngravingLines(selectedEngravingType),
      },
    });

    document.dispatchEvent(engravingTypeEvent);
  }

  /**
   * Initializes engraving types and previews.
   */
  initializeEngraving() {
    this.hideAllElements(".engraving-type-item");
    this.hideAllElements(".engraving-preview-element");

    const defaultOption = this.getDefaultEngravingOption();
    if (!defaultOption) return;
    this.showEngravingType(defaultOption.engravingType);
    this.showEngravingPreview(defaultOption.engravingType);
  }

  handleEngravingLineInput(event) {
    const { line, value } = event.detail;
    this.engravingPreviewContainer
      .querySelectorAll(".engraving-preview-element")
      .forEach((el) => {
        let engravingLine = el.querySelector(`[data-engraving-line="${line}"]`);
        if (!engravingLine) return;

        engravingLine.innerHTML = value ? value : `Engraving Line ${line}`;
      });
  }

  /**
   * Displays the selected engraving type.
   * @param {string} type - The engraving type.
   */

  showEngravingType(type) {
    const input = this.engravingTypesContainer.querySelector(
      `.engraving-type-item[data-engraving-type="${type}"] input[type="radio"]`
    );
    if (input) input.checked = true;

    this.currentProductEngravingOptions.forEach(({ engravingType }) => {
      const typeItem = this.engravingTypesContainer.querySelector(
        `.engraving-type-item[data-engraving-type="${engravingType}"]`
      );
      if (typeItem) typeItem.style.display = "block";
    });
  }

  /**
   * Displays the corresponding engraving preview.
   * @param {string} type - The engraving type.
   */
  showEngravingPreview(type) {
    const preview = this.engravingPreviewContainer.querySelector(
      `[data-engraving-preview-type="${type}"]`
    );
    if (preview) preview.style.display = "block";
  }

  /**
   * Hides all elements matching the given selector.
   * @param {string} selector - The CSS selector.
   */
  hideAllElements(selector) {
    this.querySelectorAll(selector).forEach(
      (el) => (el.style.display = "none")
    );
  }

  getEngravingLines(engravingType) {
    return this.currentProductEngravingOptions.find(
      (option) => option.engravingType === engravingType
    ).engravingLines;
  }

  /**
   * Retrieves engraving data from the DOM.
   * @returns {Object} Parsed engraving data.
   */
  getEngravingData() {
    return JSON.parse(
      document.querySelector("#engraving-options-data").textContent
    );
  }

  /**
   * Retrieves the default engraving option.
   * @returns {Object} Default engraving option.
   */
  getDefaultEngravingOption() {
    return this.currentProductEngravingOptions[0] || [];
  }

  getSelectedEngravingType() {
    return this.engravingTypesContainer.querySelector(
      'input[name="engraving-type"]:checked'
    ).value;
  }
}

customElements.define(
  "engraving-types-and-preview-component",
  EngravingTypesAndPreview
);
